import $ from 'jquery';
import 'jquery-ui-bundle';
import Sortable from 'sortablejs';
import axios from 'axios';
import { AdminInit } from './classes/AdminInit';
import { Tabs } from './classes/Tabs';
import { Shortcutter } from './classes/Shortcutter';
import { MediaGridVersioning } from './classes/MediaGridVersioning';
import { SemanticPrioritizer } from './classes/SemanticPrioritizer';
import { ListFilter } from './classes/ListFilter';
import { TwoFactor } from './classes/TwoFactor';
import { Navigation } from './classes/Navigation';
import { Select2Ajax } from './classes/Select2Ajax';
import { CustomFormValidity } from './classes/CustomFormValidity';
import { Slider } from './classes/Slider';
import { PortalLogger } from '../../../shared/js/classes/PortalLogger';
import cssesc from 'cssesc';
import { route as ziggyRoute } from 'ziggy-js';

const route = (name, params = {}, absolute = true) => {
    return adminPath(ziggyRoute(name, params, false));
}

window.sortable = Sortable;
window.Tabs = Tabs;
window.$ = window.jQuery = $;

const bootstrap = require('bootstrap');
const fip = require('@fonticonpicker/fonticonpicker')($);
require('../../../shared/bootstrap-admin/js/bootstrap.min');
require('select2/dist/js/select2.min');
require('datatables.net-bs5/js/dataTables.bootstrap5');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-rowreorder/js/dataTables.rowReorder.js');
require('../../../shared/redactor/redactor.min');
require('../../../shared/redactor/plugins/alignment');
require('../../../shared/redactor/plugins/inlinestyle');
require('../../../shared/redactor/plugins/table');
require('../../../shared/redactor/plugins/fontsize');
require('../../../shared/redactor/plugins/fontcolor');
require('../../../shared/redactor/plugins/fontfamily');
require('../../../shared/redactor/plugins/imagemanager');
require('../../../shared/redactor/plugins/filemanager');
require('../../../shared/redactor/plugins/fullscreen');
require('../../../shared/redactor/plugins/source');
require('farbstastic/farbtastic.min');
require('jquery-lazyload');
require('dropzone');
require('spectrum-colorpicker');
require('cropit.jquery3/dist/jquery.cropit');
require('../../../shared/jquery/jquery.cookie');

document.addEventListener('DOMContentLoaded', event => {
    $('#productpictures-table').on('draw.dt', function() {
        new SemanticPrioritizer('.priority-layover', 'data-id');
    });

    new AdminInit();
    new Tabs();
    new Shortcutter();
    new MediaGridVersioning();
    new Select2Ajax();
    new CustomFormValidity();
    new Slider();

    document.querySelectorAll('input[type=checkbox]').forEach(parent => {
        parent.onclick = event => {
            document.querySelectorAll(`input[data-parent=${parent.attributes.name.value}]`).forEach(child => {
                if (!parent.checked) {
                    child.setAttribute('disabled', true);
                }
                else {
                    child.removeAttribute('disabled');
                }
            });
        }
    });

    if (document.querySelector('.dropdown-menu[role=profile]')) {
        new TwoFactor();
    }

    new Navigation();

    if (document.querySelector('nav.menu-left')) {
        new ListFilter('input[name=menu-left-query]', 'nav.menu-left');
    }

    if (document.querySelector('nav.segment-blocks')) {
        new ListFilter('input[name=segment-blocks-query]', 'nav.segment-blocks');
    }

    document.querySelectorAll('.remove-custom-translation').forEach(element => {
        const input = element.parentNode.parentNode.querySelector('input[type=text]');

        if (input.value === '') {
            element.setAttribute('disabled', '');
        }

        input.oninput = event => {
            if (input.value === '') {
                element.setAttribute('disabled', '');
            }
            else {
                element.removeAttribute('disabled');
            }
        };

        element.onclick = async event => {
            if (confirm(event.target.dataset.confirmationText)) {
                await axios.post(adminPath('admin/languages/custom-translations/delete'), {
                    language: event.target.dataset.translationLanguage,
                    variable: event.target.dataset.translationVariable,
                    type: event.target.dataset.translationType
                });

                input.value = '';
                event.target.setAttribute('disabled', '');
            }
        };
    });

    // Enable / Disable datatable delete button
    $(document).on('change', '.table.dataTable input[type="checkbox"]', function () {
        let checkedCheckBoxes = $('.table.dataTable').find('input[type="checkbox"]:checked').length,
            deleteButton      = $('.form-actions .btn.btn-delete');

        if (checkedCheckBoxes > 0) {
            deleteButton.removeAttr('disabled');
        } else {
            deleteButton.attr('disabled', true);
        }
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    $('table').on('init.dt', function () {
        $('.dt-length .dt-input').addClass('form-select form-select-sm');
        $('.dt-search .dt-input').addClass('form-control form-control-sm');
    });

    document.querySelectorAll('*[data-scout-target]').forEach(element => {
        const target = cssesc(element.dataset.scoutTarget, { isIdentifier: true });

        if (target) {
            const buttons  = document.querySelectorAll(`*[data-scout-target=${target}]`);
            const dropdown = document.querySelector(`*[data-scout-target=${target}]`).parentNode.parentNode.parentNode;

            dropdown.addEventListener('show.bs.dropdown', function (event) {
                const target        = cssesc(event.target.parentNode.querySelector('.dropdown-item').dataset.scoutTarget, { isIdentifier: true });
                const textarea      = document.querySelector(`*[data-scout-source=${target}]`);
                const textareaValue = removeHTMLTags(textarea.value.trim());

                if (textareaValue.length > 3) {
                    buttons.forEach(button => {
                        button.removeAttribute('disabled');
                        button.classList.remove('disabled');
                    });
                } else {
                    buttons.forEach(button => {
                        button.setAttribute('disabled', 'disabled');
                        button.classList.add('disabled')
                    });
                }
            });
        }
    });

    document.querySelectorAll('*[data-portal-logger-event]').forEach(element => {
        new PortalLogger(element);
    });

    document.querySelectorAll('*[data-scout-target]').forEach(element => {
        element.onclick = event => {
            event.preventDefault();
            
            const element = event.target.closest('[data-scout-target]');

            if (element.hasAttribute('disabled')) {
                return;
            }

            const dataset = element.dataset;

            const target = cssesc(dataset.scoutTarget, { isIdentifier: true });
            
            if (target) {
                const url           = dataset.scoutUrl;
                const textarea    = document.querySelector(`*[data-scout-source=${target}]`);
                const textareaValue = removeHTMLTags(textarea.value.trim());
                const promptTemplate       = JSON.parse(dataset.scoutPrompt);
                const prompt        = promptTemplate.replace('<user input>', textareaValue);

                open(url+encodeURIComponent(prompt), '_blank');
            }
        };
    });
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function removeHTMLTags(htmlString) {
    // Create a new DOMParser instance
    const parser = new DOMParser();
    // Parse the HTML string
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Extract text content
    const textContent = doc.body.textContent || "";
    // Trim whitespace
    return textContent.trim();
}
